import { combineReducers } from '@reduxjs/toolkit';
import sideBarRightReducer from '../components/SideBarRight/sidebar-right-slice';

const rootReducer = combineReducers({
  sideBarRightReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
